/* eslint-disable no-sparse-arrays */
import type { RouteRecordRaw } from 'vue-router'
import { createRouter, createWebHistory } from 'vue-router'

export const routes: Array<RouteRecordRaw> = [
  {
    name: 'HomePage',
    path: '/',
    component: () => import('@/views/HomePage.vue')
  },
  {
    name: 'MarketMeter',
    path: '/MarketMeter',
    component: () => import('@/views/MarketMeter.vue')
  },
  {
    name: 'BlackBoxStrategiesPage',
    path: '/BlackBoxStrategiesPage',
    component: () => import('@/views/BlackBoxStrategiesPage.vue')
  },
    {
    name: 'BlackBoxStrategiesDetailsPage',
    path: '/BlackBoxStrategiesDetailsPage/:id?',
    component: () => import('@/views/BlackBoxStrategiesDetailsPage.vue')
  },
  {
    name: 'LearnPage',
    path: '/LearnPage',
    component: () => import('@/views/LearnPage.vue')
  },
  {
    name: 'NameError',
    path: '/showesignnameerror',
    component: () => import('@/views/errors/ErrorPage.vue')
  },
  {
    name: 'SimulatorPage',
    path: '/SimulatorPage/:editStrategyName?',
    component: () => import('@/views/SimulatorPage.vue'),
    props: (route) => {
      return {
        editStrategyName: route?.params?.editStrategyName?.toString()
      }
    }
  },
  {
    name: 'AssesmentPage',
    path: '/AssesmentPage',
    component: () => import('@/views/AssesmentPage.vue')
  },
  {
    name: 'FaqPage',
    path: '/FaqPage',
    component: () => import('@/views/FaqPage.vue')
  },
  {
    name: 'TermsPage',
    path: '/TermsPage',
    component: () => import('@/views/TermsPage.vue')
  },
  {
    name: 'SampleStrategiesPage',
    path: '/SampleStrategiesPage',
    component: () => import('@/views/SampleStrategiesPage.vue')
  },
  {
    name: 'DashboardPage',
    path: '/DashboardPage',
    component: () => import('@/views/DashboardPage.vue')
  },
  {
    name: 'TradingDashboard',
    path: '/TradingDashboard',
    component: () => import('@/views/TradingDashboard.vue')
  },
  {
    name: 'MFDashboardPage',
    path: '/MFDashboardPage',
    component: () => import('@/views/MFDashboardPage.vue')
  },
  {
    name: 'SummaryPage',
    path: '/SummaryPage',
    component: () => import('@/views/SummaryPage.vue'),
    props: (route) => {
      return {
        pageType: route?.query.pageType?.toString()
      }
    }
  },
  {
    name: 'TradeSummaryPage',
    path: '/TradeSummaryPage',
    component: () => import('@/views/TradeSummaryPage.vue'),
    props: (route) => {
      return {
        pageType: route?.query.pageType?.toString()
      }
    }
  },
  {
    name: 'MFSummaryPage',
    path: '/MFSummaryPage',
    component: () => import('@/views/MFSummaryPage.vue'),
    props: (route) => {
      return {
        pageType: route?.query.pageType?.toString()
      }
    }
  },
  {
    name: 'MFEditPage',
    path: '/MFEditPage/:editStrategyName?',
    component: () => import('@/views/MFEditPage.vue'),
    props: (route) => {
      return {
        editStrategyName: route?.params?.editStrategyName?.toString(),
        pageType: route?.query.pageType?.toString()
      }
    }
  },
  {
    name: 'EditPage',
    path: '/EditPage/:editStrategyName?',
    component: () => import('@/views/EditPage.vue'),
    props: (route) => {
      return {
        editStrategyName: route?.params?.editStrategyName?.toString(),
        pageType: route?.query.pageType?.toString()
      }
    }
  },
  {
    name: 'TradeEditPage',
    path: '/TradeEditPage/:editStrategyName?',
    component: () => import('@/views/TradeEditPage.vue'),
    props: (route) => {
      return {
        editStrategyName: route?.params?.editStrategyName?.toString(),
        pageType: route?.query.pageType?.toString()
      }
    }
  },
  {
    name: 'CreatePage',
    path: '/CreatePage',
    component: () => import('@/views/CreatePage.vue'),
    props: (route) => {
      return {
        popular: route?.params?.popular?.toString(),
        pageType: route?.query.pageType?.toString()
      }
    }
  },
  {
    name: 'CreateTradingPage',
    path: '/CreateTradingPage',
    component: () => import('@/views/CreateTradingPage.vue'),
    props: (route) => {
      return {
        popular: route?.params?.popular?.toString(),
        pageType: route?.query.pageType?.toString()
      }
    }
  },
  {
    name: 'MFCreatePage',
    path: '/MFCreatePage',
    component: () => import('@/views/MFCreatePage.vue'),
    props: (route) => {
      return {
        popular: route?.params?.popular?.toString(),
        pageType: route?.query.pageType?.toString()
      }
    }
  },
  {
    name: 'MFBasketPage',
    path: '/MFBasketPage/:editStrategyName?',
    component: () => import('@/views/MFBasketPage.vue')
  },
  {
    name: 'BasketPage',
    path: '/BasketPage/:editStrategyName?',
    component: () => import('@/views/BasketPage.vue')
  },
  {
    name: 'TradeBasketPage',
    path: '/TradeBasketPage/:editStrategyName?',
    component: () => import('@/views/TradeBasketPage.vue')
  },
  {
    name: 'PositionsPage',
    path: '/PositionsPage/:editStrategyName?',
    component: () => import('@/views/PositionsPage.vue'),
    props: (route) => {
      return {
        pageType: route?.query.pageType?.toString()
      }
    }
  },
  {
    name: 'MFPositionsPage',
    path: '/MFPositionsPage/:editStrategyName?',
    component: () => import('@/views/MFPositionsPage.vue')
  },
  {
    name: 'TradePositionsPage',
    path: '/TradePositionsPage/:editStrategyName?',
    component: () => import('@/views/TradePositionsPage.vue'),
    props: (route) => {
      return {
        pageType: route?.query.pageType?.toString()
      }
    }
  },
  {
    name: 'LogsPage',
    path: '/LogsPage/:editStrategyName?',
    component: () => import('@/views/LogsPage.vue'),
    props: (route) => {
      return {
        pageType: route?.query.pageType?.toString()
      }
    }
  },
  {
    name: 'TradingBacktestPage',
    path: '/TradingBacktestPage/:editStrategyName?',
    component: () => import('@/views/TradingBacktestPage.vue'),
    props: (route) => {
      return {
        pageType: route?.query.pageType?.toString()
      }
    }
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

export default router
